export const SUBSCRIPTION_PURCHASE_PATHS = ['/products', '/profile', '/payment-history'];

export const isSubscriptionPurchasePath = (pathname) =>
  SUBSCRIPTION_PURCHASE_PATHS.includes(pathname);

export const resolveRemainingDays = (subscription) => {
  if (!subscription) return null;

  const directValue =
    subscription.remainingDays ??
    subscription.daysRemaining ??
    subscription.remainingDayCount;

  if (Number.isFinite(Number(directValue))) {
    return Math.max(0, Math.ceil(Number(directValue)));
  }

  const endDateValue =
    subscription.endDate ??
    subscription.endAt ??
    subscription.expiresAt ??
    subscription.expiredAt;

  if (!endDateValue) return null;

  const endDate = new Date(endDateValue);
  if (Number.isNaN(endDate.getTime())) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  const diffMs = endDate.getTime() - today.getTime();
  return Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
};

export const isSubscriptionActive = (subscription) => {
  if (!subscription) return false;
  if (subscription.active === true) return true;
  if (subscription.active === false) return false;
  const days = resolveRemainingDays(subscription);
  return days != null && days > 0;
};

export const normalizeSubscriptions = (data) => {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  return [data];
};

export const buildSubscriptionMap = (subscriptions = []) => {
  const list = normalizeSubscriptions(subscriptions);
  return new Map(
    list
      .filter((subscription) => subscription?.powerLocationId != null)
      .map((subscription) => [Number(subscription.powerLocationId), subscription])
  );
};

export const getMinRemainingDays = (subscriptions = []) => {
  const list = normalizeSubscriptions(subscriptions);
  const days = list
    .map((subscription) => resolveRemainingDays(subscription))
    .filter((value) => value != null);

  if (days.length === 0) return null;
  return Math.min(...days);
};

export const countActiveSubscriptions = (subscriptions = []) =>
  normalizeSubscriptions(subscriptions).filter(isSubscriptionActive).length;

export const extractPowerLocationIdFromPath = (pathname) => {
  const match = pathname.match(/^\/power-plant\/(\d+)/);
  return match ? Number(match[1]) : null;
};

export const formatSubscriptionStatus = (subscription) => {
  if (!subscription) {
    return { label: '이용기간 종료', className: 'subscription-badge--expired' };
  }
  if (isSubscriptionActive(subscription)) {
    const days = resolveRemainingDays(subscription);
    return {
      label: days != null ? `D-${days}일` : '이용 중',
      className: 'subscription-badge--active',
    };
  }
  return { label: '이용기간 종료', className: 'subscription-badge--expired' };
};
